// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3U-I2D8OQFJi1aguG5LG0v{margin-bottom:10px}", ""]);
// Exports
exports.locals = {
	"link": "_3U-I2D8OQFJi1aguG5LG0v"
};
module.exports = exports;
